module.exports = __webpack_public_path__ + "static/img/celoscope-detail-6.5f2a45d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-6.jpg
// module id = HQ7C
// module chunks = 52